import { render, staticRenderFns } from "./DetailsReaderObject.vue?vue&type=template&id=314347aa&"
import script from "./DetailsReaderObject.vue?vue&type=script&lang=js&"
export * from "./DetailsReaderObject.vue?vue&type=script&lang=js&"
import style0 from "./DetailsReaderObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports